import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import { colors } from "../../../theme/theme";

//components
import Avatar from "react-avatar";
import { toast } from "react-toastify";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import {MdOutlineClose, MdStar } from 'react-icons/md';
import { RiWhatsappLine } from 'react-icons/ri';
import { ContactForm, CloseButton } from "./styles";
import Error from "../Error";

//services
import { requestSupportContact } from "../../services/profile.service";
import UsuarioContext from "../../../context/userContext/context";

interface ButtonContactPrps {
  signature: boolean
}

const validationSchema = Yup.object({
  message: Yup.string().required("Este campo é obrigatório"),
}).required();

export function ButtonContact({ signature = false }: ButtonContactPrps) {
  const { t: translation } = useTranslation();
  const { user } = useContext(UsuarioContext);
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });

  const [loading, setLoading] = useState<boolean>(false)
  const [showContent, setShowContent] = useState<boolean>(false)
  const [showContactForm, setShowContactForm] = useState<boolean>(false)

  useEffect(() => {
    if (!showContent) {
      setShowContactForm(false)
    }
  }, [showContent])

  const onSubmit = (params: any) => {
    setLoading(true)

    let objSupportContact = {
      username: user.username,
      email: user.email,
      subject: "Assinatura",
      message: params.message,
    }

    requestSupportContact(objSupportContact).then(() => {
      toast.success("Solicitação enviada com sucesso!");
      setLoading(false)
      setShowContent(false)
      setShowContactForm(false)
    }).catch((err) => {
      toast.error(err.response.data[0]);
      setLoading(false)
      setShowContent(false)
      setShowContactForm(false)
    })
  };

  return (
    <>
      {showContent &&
        <ContactForm>
          <CloseButton>
            <MdOutlineClose onClick={() => setShowContent(false)} />
          </CloseButton>
          {
            showContactForm ? (
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="d-block">
                  <Col xs={12}><h6 className="text-darker-grey"><b>{translation('popup.title')}</b></h6></Col>
                  <Col xs={12} className="mb-4"><h6>{translation('popup.subtitle')}</h6></Col>

                  <Col xs={12} className="mb-4">
                    <Row className="align-items-center">
                      <Col xs={3} lg={2}>
                        <Avatar size="60" round={true} name={user.name !== "" ? user.name : "U S"} src={user.picture ?? ""} color={!user.picture ? colors.mainColors.blueberry : ""} />   
                      </Col>
                      <Col xs={9} lg={10} className="mt-2">
                        <h6 className="text-darker-grey">{user.username}</h6>
                        <h6 className="text-darker-grey">{user.email}</h6>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={12} className="mb-2">
                    <Form.Group className="mb-2">
                      <Form.Label className="text-darker-grey">{translation('contactForm.labelMessage')}:</Form.Label>
                      <Form.Control as="textarea" defaultValue="Olá, gostaria de fazer a assinatura" rows={4} style={{ resize: 'none' }} placeholder={translation('contactForm.labelMessage')}  {...register("message", { required: true })} />
                      {errors.message ? (<div className="w-100"> <Error>{errors.message?.message}</Error> </div>) : ""}
                    </Form.Group>
                  </Col>
                  <Row className="justify-content-end px-3 py-2">
                    <Col xs={2}>
                      {
                        loading ? (
                          <Spinner animation="border" variant="primary" />
                        ) : (
                          <Button variant="primary" className="btn-rounded" type="submit">{translation('contactForm.send')}</Button>
                        )
                      }
                    </Col>
                  </Row>
                </Row>
              </Form>
            ) : (
              <Row className="d-block">
                <Col xs={12}><h6 className="text-darker-grey"><b>{translation('popup.title')}</b></h6></Col>
                <Col xs={12}><h6>{translation('popup.subtitle')}</h6></Col>
                <Col xs={12}>
                  <Row>
                    <Col xs={6}>
                      <Button className="w-100" variant="outline-primary" onClick={() => window.open('https://dstoreconteudos.com.br/#planos', '_blank')}>
                        <MdStar style={{ fontSize: '20px', marginBottom: '3px'}}/>&nbsp; {translation('components.menu.buyPlans')}
                      </Button>
                    </Col>
                    <Col xs={6}>
                      <Button className="w-100" variant="outline-primary" onClick={() => window.open('https://api.whatsapp.com/send/?phone=554891177086&text&app_absent=0', '_blank')}>
                        <RiWhatsappLine style={{ fontSize: '20px', marginBottom: '3px' }} />&nbsp; WhatsApp
                      </Button>
                    </Col>
                    {/* <Col xs={6}>
                      <Button className="w-100" variant="outline-primary" onClick={() =>setShowContactForm(true)}>
                        <MdOutlineEmail style={{ fontSize: '20px', marginBottom: '3px'}}/>&nbsp; Email
                      </Button>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
            )
          }
        </ContactForm>
      }
    </>
  )
}